import { FlexGrid, Image, Link, Panel, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TopSpottersList.module.css';

const cx = classnames.bind(styles);

export default function TopSpottersList({ topSpotters }) {
  const { t } = useTranslation('account');

  if (topSpotters.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <Panel className={cx('spotterItemsContainer')} color="white" padded={false} bordered rounded>
        {topSpotters.map((spotter, idx) => (
          <FlexGrid className={cx('gridRowAdditions')} key={spotter.name}>
            <FlexGrid.Column mobile={1}>
              <div className={cx('regularNumber', { champNumber: !!spotter.streak })}>
                {idx + 1}
              </div>
            </FlexGrid.Column>
            <FlexGrid.Column mobile={2} tablet={1} desktop={2}>
              <Image
                alt={t('avatarImage', { ns: 'account', memberId: spotter.name })}
                className={cx('avatarIcon')}
                src={spotter.avatar}
              />
            </FlexGrid.Column>
            <FlexGrid.Column mobile={8} tablet={9} desktop={8}>
              <Link
                bold
                color="grey"
                to={`https://www.gasbuddy.com/member/${spotter.name.toLowerCase()}`}
              >
                {spotter.name}
              </Link>
            </FlexGrid.Column>
            <FlexGrid.Column mobile={1}>
              <Text centered>
                {spotter.count}
              </Text>
            </FlexGrid.Column>
          </FlexGrid>
        ))}
      </Panel>
    </Fragment>
  );
}

TopSpottersList.propTypes = {
  topSpotters: PropTypes.arrayOf(PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    streak: PropTypes.number.isRequired,
  })),
};

TopSpottersList.defaultProps = {
  topSpotters: [],
};
